<template>
	<div>
		<img width="30" src="../../../../static/website/images/noData.svg" alt="Icon" v-if="appTheme">
		<img width="30" src="../../../../static/website/images/light-bg-record.svg" alt="Icon" v-else>
		<p v-html="text || 'No Data'"></p>
	</div>
</template>
<script>
import { commonAllmixins } from '@/plugins/commonAll'
	export default{
		name:'no-data-image',
		mixins: [commonAllmixins],
		props:['text']
	}
</script>


// WEBPACK FOOTER //
// src/components/website/shared/no-data.vue